import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { PageHeaderComponent } from '@libs/common/components';
import { ProductPriceVisibilityService } from '@libs/shared/ui';
import { AddToCartComponent } from '../../elements';
import { ProductDetailFormBaseComponent } from '../product-detail-form-base.component';
import { ProductDetailInfoComponent } from '../product-detail-info';
import { ProductDetailPricesComponent } from '../product-detail-prices';
import { ProductDetailHeaderComponent } from "../product-detail-header/product-detail-header.component";

@Component({
  selector: 'ui-product-detail-form',
  templateUrl: './product-detail-form.component.html',
  styleUrls: [
    '../product-detail-form-base.component.scss',
    './product-detail-form.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductDetailInfoComponent,
    ProductDetailPricesComponent,
    AddToCartComponent,
    NgTemplateOutlet,
    PageHeaderComponent,
    ProductDetailHeaderComponent
],
})
export class ProductDetailFormComponent extends ProductDetailFormBaseComponent {
  public priceVisibilityService: ProductPriceVisibilityService = inject(ProductPriceVisibilityService);
  public productHasPrice: Signal<boolean> = computed(() => !!this.product().prices);
  public productPriceIsVisible: Signal<boolean> = computed(() => this.priceVisibilityService.arePricesVisible(this.product().prices));
}
